import React, {Component} from 'react';
import {NextTrainBostonHeader, NextTrainBostonNav} from '../links';

const styles = {
    container: {
        fontSize: '1.2rem',
        lineHeight: 1.5,
        margin: '0 auto',
        maxWidth: 800,
        padding: '0 1rem',
    },
    header: {
        textAlign: 'center',
    },
    summary: {
        fontWeight: 'bold',
        marginBottom: '1rem',
    },
};

let _this;

class NextTrainBostonUserAgreement extends Component {
    constructor(props, context) {
        super(props, context);
        _this = this;
    }

    render() {
        return (
            <div className="container">
                <NextTrainBostonNav navigate={_this.props.navigate} selected="NextTrainBostonEULA"/>
                <br/>
                <NextTrainBostonHeader/>
                <br/>
                <br/>
                <br/>
                <div style={styles.container}>
                    <h1 style={styles.header}>Terms of Use</h1>
                    <p style={styles.summary}>
                        By using Next Train Boston, you agree to these Terms of Use. The app shows published schedules
                        for your convenience; it does not show real-time service, and you remain responsible for
                        checking official sources before you travel.
                    </p>

                    <h2>The Service</h2>
                    <p>
                        Next Train Boston (the "Services") is a timetable app for the MBTA commuter rail and ferries,
                        made by AnswerSolutions LLC. It shows scheduled departures, routes and your saved commute,
                        on your iPhone, in its widget and on Apple Watch.
                    </p>

                    <h2>Schedule Accuracy</h2>
                    <p>
                        Schedules are taken from the MBTA's public GTFS feed and updated regularly, but they may
                        differ from actual service because of delays, cancellations, holidays, construction, track
                        changes or updates published after the app last refreshed. The app does not show real-time
                        arrivals, service alerts or track assignments. Always check mbta.com, station announcements
                        and official MBTA channels before you travel.
                    </p>

                    <h2>No Affiliation</h2>
                    <p>
                        Next Train Boston is an independent app. It is not affiliated with, endorsed by or sponsored
                        by the Massachusetts Bay Transportation Authority (MBTA) or the Massachusetts Department of
                        Transportation (MassDOT). Schedule data is used under the MassDOT developer license. MBTA and
                        related names are trademarks of their respective owners.
                    </p>

                    <h2>Use of the Services</h2>
                    <p>
                        You agree to use the Services only for lawful, personal purposes and not to copy, resell,
                        reverse engineer or redistribute the app or its data except as allowed by law or by the
                        applicable App Store terms. Users who are at least 13 years old may use the Services; if you
                        are under 18, you must have permission from a parent or legal guardian.
                    </p>

                    <h2>Fees</h2>
                    <p>
                        The Services are currently free. If we introduce paid features in the future, we will describe
                        them in the app before you are charged, and purchases will be handled by the App Store under
                        its terms.
                    </p>

                    <h2>Intellectual Property</h2>
                    <p>
                        The app, its design, icon and text are the property of AnswerSolutions LLC and are protected
                        by copyright, trademark and other intellectual property laws.
                    </p>

                    <h2>Disclaimer of Warranties</h2>
                    <p>
                        The Services are provided on an "as is" and "as available" basis, without warranties of any
                        kind, either express or implied, including without limitation warranties of accuracy,
                        merchantability, fitness for a particular purpose or non-infringement. We do not guarantee that
                        the Services will be uninterrupted or error-free, or that any schedule shown is correct.
                    </p>

                    <h2>Limitation of Liability</h2>
                    <p>
                        In no event shall AnswerSolutions LLC or its affiliates, officers, directors, employees or
                        agents be liable for any direct, indirect, incidental, special or consequential damages,
                        including a missed train or ferry, arising from or related to your use of or inability to use
                        the Services. This limitation applies regardless of the legal theory, whether in contract, tort
                        or otherwise.
                    </p>

                    <h2>Modification of Terms</h2>
                    <p>
                        We may update these Terms at any time by posting the revised Terms on this page. Your continued
                        use of the Services after that constitutes acceptance of the revised Terms.
                    </p>

                    <h2>Governing Law</h2>
                    <p>
                        These Terms and your use of the Services are governed by the laws of the United States, without
                        regard to its conflict of law provisions.
                    </p>

                    <h2>Contact Us</h2>
                    <p>
                        If you have any questions about these Terms, please contact us at support@answersolutions.net.
                    </p>
                </div>
                <br/>
                <br/>
                <br/>
                <NextTrainBostonNav navigate={_this.props.navigate} selected="NextTrainBostonEULA" withProducts/>
            </div>
        );
    }
}

export default NextTrainBostonUserAgreement;
